<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
<template>
  <div>
    <p>不用意な操作が行われました。申込者ございませんがブラウザを閉じ、<br>URLを確認し、アクセスしなおしてください。</p>
  </div>
</template>
<script>
  export default {
    name: 'UtilityError',
    data() {
      return {
      }
    },
    created: function () {
      UtilityConsoleLog.consoleLog('UtilityError::created Start')

      UtilityConsoleLog.consoleLog('UtilityError::created End')
    }
  }
</script>





// WEBPACK FOOTER //
// src/components/UtilityError.vue